{
	"adj_HSL": "HSL",
	"adj_basic": "Basic",
	"adj_basicCurves": "Basic Curves",
	"adj_blacks": "Blacks",
	"adj_calibration": "Calibration",
	"adj_clarity": "Clarity",
	"adj_colorGrading": "Color Grading",
	"adj_colorNoiseReduction": "Color Noise Reduction",
	"adj_colorProfile": "Color Profile",
	"adj_contrast": "Contrast",
	"adj_cropGroup": "Crop",
	"adj_curves": "Curves",
	"adj_dehaze": "Dehaze",
	"adj_detail": "Detail",
	"adj_disableProfileLookTable": "Disable Profile Look Table",
	"adj_effects": "Effects",
	"adj_exposure": "Exposure",
	"adj_grainGroup": "Grain",
	"adj_healing": "Healing",
	"adj_highlights": "Highlights",
	"adj_lensCorrection": "Lens Correction",
	"adj_luminanceNoiseReduction": "Luminance Noise Reduction",
	"adj_lut": "LUT",
	"adj_masking": "Masking",
	"adj_parametricCurves": "Parametric Curves",
	"adj_pointColors": "Point Colors",
	"adj_profile": "Color Profile",
	"adj_saturation": "Saturation",
	"adj_shadows": "Shadows",
	"adj_sharpen": "Sharpen",
	"adj_temperature": "Temperature",
	"adj_texture": "Texture",
	"adj_tint": "Tint",
	"adj_transform": "Transform",
	"adj_userLutId": "User LUT ID",
	"adj_userLutStrength": "User LUT Strength",
	"adj_userLutTitle": "User LUT Title",
	"adj_vibrance": "Vibrance",
	"adj_vignetteGroup": "Vignette",
	"adj_whites": "Whites",
	"ariaCheckAll": "Check All",
	"ariaCheckNone": "Check None",
	"checkAll": "Check All",
	"checkNone": "Check None",
	"confirmCopy": "Copy",
	"confirmCreate": "Create",
	"copySettings": "Copy Settings",
	"createPreset": "Create Preset",
	"untitledPreset": "Untitled Preset"
}
